import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { PoS } from '../../app/models/PoS';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { Zone } from '../../app/models/Zone';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { Storage } from '../../../node_modules/@ionic/storage';
import { FileModel } from '../../app/models/FileModel';
import { PosType } from '../../app/models/PosType';

@Component({
  selector: 'page-pos',
  templateUrl: 'pos.html',
})
export class PosPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('posModal')
  private posModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('posForm')
  private posForm: NgForm;

  @ViewChild('fileInput')
  private fileInput: ElementRef;

  private pageName: string = 'page-pos';
  private posList: PoS[] = [];
  private posCodes: string[] = [];
  private posNames: string[] = [];
  private initialValue: string;
  private nameInitialValue: string;
  private currentPos;
  private zones: Zone[] = [];
  private navControllerService: NavControllerService;
  private currentConfiguration: Config;
  private selectedFile: File;
  private posTypeEnum = PosType;

  constructor(
    public navCtrl: NavController,
    private backendService: PaytronBackendService,
    private app: App,
    public navParams: NavParams,
    private configService: ConfigService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.currentConfiguration = this.configService.getConfiguration();
    this.currentPos = new PoS();
    this.currentPos.type = PosType.Mobile;
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.posModal.config = this.currentConfiguration.modalConfig;
    this.loadZones();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getPosList();
  }

  private getPosList() {
    this.backendService.getPoSList().subscribe(
      (posList) => {
        this.posList = posList;
        this.posCodes = [];
        this.posNames = [];
        posList.forEach(p => {
          this.posCodes.push(p.code);
          this.posNames.push(p.name);
        });
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadZones() {
    this.backendService.getZones().subscribe(
      (zones) => {
        this.zones = zones;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addPos() {
    this.currentPos = new PoS();
    this.currentPos.type = PosType.Mobile;
    this.posForm.resetForm();
    this.initialValue = null;
    this.nameInitialValue = null;
    this.fileInput.nativeElement.value = '';
    this.showPosModal();
  }

  editPos(pos: PoS) {
    this.currentPos = pos;
    this.initialValue = pos.code;
    this.nameInitialValue = pos.name;
    this.fileInput.nativeElement.value = '';
    this.showPosModal();
  }

  deletePos() {
    this.backendService
      .deletePos(this.currentPos)
      .subscribe(
        (data) => {
          this.getPosList();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  submitPos(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdatePos(this.currentPos)
      .subscribe(
        (pos) => {
          this.getPosList();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closePosModal();
      });
  }

  onFileChanged(event) {
    if (event.target.files[0]) {
      this.selectedFile = event.target.files[0];
      this.uploadData();
    }
  }

  uploadData() {
    const uploadData = new FormData();
    uploadData.append('files', this.selectedFile, this.selectedFile.name);
    this.backendService.addFile(uploadData).subscribe(
      (data: FileModel) => {
        this.currentPos.icon = data.name;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  compareZone(zone1: Zone, zone2: Zone): boolean {
    return zone1 && zone2 ? zone1.uuid === zone2.uuid : zone1 === zone2;
  }

  showPosModal() {
    this.posModal.show();
  }

  closePosModal() {
    this.posModal.hide();
  }

  showConfirmModal(pos) {
    this.currentPos = pos;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showZonesPage() {
    this.navControllerService.showZonesPage();
  }

  showPosAppPage() {
    this.navControllerService.showPosAppPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pos/pos.ts